import { useEffect } from 'react'; // Import useEffect for side effects
import { useNavigate } from 'react-router-dom'; // Assuming you are using React Router

import { getBaseUrl } from '../utils/index';
import axios from 'axios';
import { useLogout } from '../hooks/useLogout';

export const axiosInstance = axios.create({
  baseURL: getBaseUrl(),
});

export const useAxiosInterceptor = () => {
  const navigate = useNavigate();
  const { logout: handleLogout } = useLogout();

  useEffect(() => {
    // Request interceptor
    const requestInterceptor = axiosInstance.interceptors.request.use(
      (config) => {
        const user = localStorage.getItem('user');
        if (user) {
          const { token } = JSON.parse(user);
          if (token) {
            config.headers.Authorization = token;
          }
        }
        return config;
      },
      (error) => {
        return Promise.reject(error);
      }
    );

    // Response interceptor
    const responseInterceptor = axiosInstance.interceptors.response.use(
      (response) => {
        return response;
      },
      (error) => {
        if (error.response) {
          const status = error.response.status;
          if (status === 401 || status === 403) {
            handleLogout();
            navigate('/login');
          }
        }
        return Promise.reject(error);
      }
    );

    return () => {
      // Remove the interceptors when the component unmounts
      axiosInstance.interceptors.request.eject(requestInterceptor);
      axiosInstance.interceptors.response.eject(responseInterceptor);
    };
  }, [navigate, handleLogout]);

  return null; // This is a custom hook, so it doesn't return JSX
};

export default useAxiosInterceptor;

{/*import { getBaseUrl } from "../utils/index";
import axios from "axios";

export const axiosInstance = axios.create({
  baseURL: getBaseUrl(),
});*/}